import { AddressBook } from '../state'

export interface State {
    locale: {}
    config: { titles: Array<string> }
    router: { location: { path: string } }
    countries: Array<string>
    addressBook: AddressBook
}

export default function getAddresses(state: State) {
    const { locale, config, router, countries, addressBook } = state
    const { location } = router
    const { titles } = config

    return {
        titles,
        locale,
        location,
        addressBook,
        countries
    }
}
